module.exports = __webpack_public_path__ + "static/img/curliv-technology.249360ed.png";